// ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSecureApplication } from '../hooks/KeycloackConnection';
import { useProfileQuery } from '../pages/users/profileSlice';

const ProtectedRoute = ({ children, roles }:{children: JSX.Element, roles:string[]}) => {

  const {hasAnyPerm} = useSecureApplication()
  const { data: profileApi } = useProfileQuery();


  // If the user is authentificated, check that he has the necessary rights to connect to the requested page
  if (profileApi &&!hasAnyPerm(...roles) ) {
    return <Navigate to="/roles-insuffisants" />;
  }

  //if the user is disconnected, we return children component to have the correct redirect URL for keycloack
  //if the user is connected and has the necessary rights, the page is displayed
  return children;
};

export default ProtectedRoute;